import React, { Component } from 'react';

const $= window.$;


class IseekObservers extends Component {
	constructor(props) {
		super(props);

		this.getCheck = this.getCheck.bind(this);
	}

	getCheck(){
		var checkedValues = $('.chk_slct:checked').map(function() {
			return this.value;
		}).get();
		//alert(checkedValues);
	    // var values = checkedValues.split('_');
	    // values = (values[1])+values[2];
		this.props.sendEmails(checkedValues);
	 //    this.setState({
		// 	checkedValues: checkedValues
		// });
	    // this.getData();

	}

		render() {
        
			const {Observers} = this.props;
			//alert(JSON.stringify({Observers}));

			 let rows = Observers.map((observer,i) => {
			 	var value = i+1; 
                return (
		                   <tr key={i}>
			                   	<td><input type="checkbox"  name={"chkAssessor_id"+value} id={"chkAssessor_id"+value} value={'OB_'+observer.assessor_id+'_'+observer.assessor_name+'_'+observer.email} className="chk_slct" onClick={(e)=>this.getCheck(e)}/></td>
				                <td>{observer.assessor_name}</td>
				                <td>{observer.email}</td>
		                   </tr> 
		                )
		       });

		       (rows.length == 0) ? rows = <tr align="center"><td colSpan="3">No Observer(s) found.</td></tr> : rows = rows
			
			return (

				 	
			       
					<table  width="100%" border="1" style={{border: 'solid 1px #e7e7e7'}}>
			            <thead>
			              <tr>
			                <th></th>
			                <th align="left"><strong>Name</strong></th>
			                <th align="left"><strong>Email</strong></th>
			              </tr>
			            </thead>

					  	<tbody>
					  		{rows}
					  	</tbody>
					</table>

			);
		}
}

export default IseekObservers;



// WEBPACK FOOTER //
// ./src/personal_interactions/iseek/IseekObservers.js